import { ID_BUNDLE_ADDITIONAL_SEATS } from 'src/entities/bundles/model/consts';
import { getIdBundleBase } from './get-id-bundle-base';

/**
 * Returns every version of the seats add-on: the original and its copies.
 * @param bundles - The add-ons.
 */
export const getBundlesSeats = <TBundle extends { id: string }>(
  bundles: TBundle[],
): TBundle[] => bundles.filter(({ id }) => getIdBundleBase(id) === ID_BUNDLE_ADDITIONAL_SEATS);
